/* MetaBeauty · Echte Ergebnisse – Karten, Slider, Warenkorb, Overlay der Lasche VORHER / NACHHER */
(function () {
  if (window.MBE) return;
  var html = document.documentElement;
  var MBE = (window.MBE = {});

  function anyOpen() {
    return document.querySelector('.mbe-card.is-open, .mbe-ov.is-open');
  }
  /* Tablet / Desktop (ab 750 px): vorherige und nächste Karte stehen sichtbar links und rechts */
  var WIDE = window.matchMedia('(min-width: 750px)');
  function wide() { return WIDE.matches; }
  var bd = null;
  /* Abdunklung liegt im selben Container wie die Karten (im Overlay sonst über allen Karten) */
  function backdrop(on) {
    var oc = document.querySelector('.mbe-card.is-open');
    if (!bd) {
      if (!on) return;
      bd = document.createElement('div');
      bd.className = 'mbe-bd';
    }
    if (on && oc && bd.parentNode !== oc.parentNode) oc.parentNode.insertBefore(bd, oc.parentNode.firstChild);
    bd.classList.toggle('is-on', on);
  }
  function syncLock() {
    html.classList.toggle('mbe-lock', !!anyOpen());
    backdrop(wide() && !!document.querySelector('.mbe-card.is-open'));
  }
  function eager(card) {
    if (!card) return;
    card.querySelectorAll('img[loading="lazy"]').forEach(function (i) { i.loading = 'eager'; });
  }
  /* Erste Fotos aller Karten im Leerlauf vorladen – Karten öffnen und Blättern ohne Wartezeit */
  function warm(root) {
    var idle = window.requestIdleCallback || function (f) { return setTimeout(f, 1200); };
    idle(function () {
      (root || document).querySelectorAll('[data-mbe-card] .mbe-card__slide:first-child img[loading="lazy"]').forEach(function (i) { i.loading = 'eager'; });
    });
  }
  function hashId() {
    return decodeURIComponent((location.hash || '').slice(1));
  }

  /* ---------- Auswertung: Ereignisse für Customer Events (GA4) + Markierung im Warenkorb ---------- */
  var src = '';
  function track(name, data) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data || {}); } catch (err) {}
  }
  function srcOf(el) {
    if (!el || !el.classList) return 'link';
    if (el.classList.contains('mb-moast-tab')) return 'lasche';
    if (el.classList.contains('mbe-chip')) return 'plakette';
    if (el.classList.contains('mbe-pslide')) return 'galerie';
    return 'link';
  }
  var seen = [], seenT = null;
  /* Markierung im Warenkorb nur mit Statistik-Einwilligung (Cookie-Banner) */
  function consentOk() {
    try { var c = window.Shopify && Shopify.customerPrivacy; return !!(c && c.analyticsProcessingAllowed && c.analyticsProcessingAllowed()); } catch (err) { return false; }
  }
  /* Versteckte Warenkorb-Attribute (_…): im Admin bei der Bestellung sichtbar, nicht für Kundinnen */
  function noteSeen(id) {
    if (id && seen.indexOf(id) < 0) seen.push(id);
    if (!consentOk()) return;
    clearTimeout(seenT);
    seenT = setTimeout(function () {
      var url = ((window.routes && window.routes.cart_update_url) || '/cart/update') + '.js';
      fetch(url.replace('.js.js', '.js'), {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { _mbe_quelle: src || 'seite', _mbe_karten: seen.slice(-10).join(',') } })
      }).catch(function () {});
    }, 1500);
  }

  /* ---------- Karte ---------- */
  var ICON_OFF = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M4 9h4l5-4v14l-5-4H4z" fill="currentColor"/><path d="M16 9l5 6M21 9l-5 6" stroke="currentColor" stroke-width="1.6" fill="none"/></svg>';
  var ICON_ON = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="M4 9h4l5-4v14l-5-4H4z" fill="currentColor"/><path d="M16 8.5a5 5 0 0 1 0 7M18.5 6a8.5 8.5 0 0 1 0 12" stroke="currentColor" stroke-width="1.6" fill="none"/></svg>';
  function setupVideos(card) {
    card.querySelectorAll('.mbe-card__slide video').forEach(function (v) {
      if (v.__mbe) return;
      v.__mbe = true;
      v.removeAttribute('controls');
      v.controls = false;
      v.muted = true; v.defaultMuted = true; v.loop = true; v.playsInline = true;
      v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('loop', '');
      v.preload = 'auto';
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'mbe-card__sound'; b.setAttribute('aria-label', 'Ton'); b.innerHTML = ICON_OFF;
      b.addEventListener('click', function (e) {
        e.stopPropagation();
        v.muted = !v.muted;
        b.innerHTML = v.muted ? ICON_OFF : ICON_ON;
        if (v.paused) v.play().catch(function () {});
      });
      v.addEventListener('click', function () { if (v.paused) v.play().catch(function () {}); else v.pause(); });
      v.parentNode.appendChild(b);
    });
  }
  function playVideos(card) {
    var slides = card.querySelector('[data-mbe-slides]');
    var vids = card.querySelectorAll('.mbe-card__slide video');
    vids.forEach(function (v, i) {
      var slide = v.closest('.mbe-card__slide');
      var visible = !slides || Math.abs(slide.offsetLeft - slides.scrollLeft) < slides.clientWidth / 2;
      if (visible) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else v.pause();
    });
  }
  function initCard(card) {
    setupVideos(card);
    if (card.__mbeInit) return;
    card.__mbeInit = true;
    var slides = card.querySelector('[data-mbe-slides]');
    var dots = card.querySelectorAll('.mbe-card__dots span');
    var idx = card.querySelector('[data-mbe-i]');
    if (slides && (dots.length || idx)) {
      slides.addEventListener('scroll', function () {
        var i = Math.round(slides.scrollLeft / slides.clientWidth);
        if (idx) idx.textContent = i + 1;
        dots.forEach(function (d, j) { d.classList.toggle('is-active', j === i); });
        clearTimeout(slides.__t);
        slides.__t = setTimeout(function () { playVideos(card); }, 150);
      }, { passive: true });
    }
  }
  function checkStory(card) {
    var story = card.querySelector('[data-mbe-story]');
    var more = card.querySelector('[data-mbe-more]');
    if (!story || !more) return;
    if (story.classList.contains('is-open')) return;
    story.classList.remove('is-short');
    var short = story.scrollHeight <= story.clientHeight + 8;
    story.classList.toggle('is-short', short);
    more.hidden = short;
  }
  function findCard(id) {
    var c = overlay && overlay.classList.contains('is-open') && overlay.querySelector('#' + CSS.escape(id));
    c = c || document.getElementById(id);
    return c && c.hasAttribute('data-mbe-card') ? c : null;
  }
  function openCard(id, push) {
    var card = findCard(id);
    if (!card || !card.hasAttribute('data-mbe-card')) return false;
    var open = document.querySelector('.mbe-card.is-open');
    if (open && open !== card) closeCardNow(open);
    card.hidden = false;
    card.classList.remove('is-side');
    card.classList.add('is-open');
    syncLock();
    initCard(card);
    var inner = card.querySelector('.mbe-card__in');
    if (inner) inner.scrollTop = 0;
    eager(card);
    eager(neighbour(card, 1));
    eager(neighbour(card, -1));
    if (wide()) wideLayout(card, 0, 0, lastDir); else { clearSides(); resetIn(inner); }
    requestAnimationFrame(function () { checkStory(card); playVideos(card); });
    setTimeout(function () { checkStory(card); }, 350);
    setTimeout(function () { checkStory(card); }, 1200);
    if (push !== false && hashId() !== id) history.pushState({ mbe: id }, '', '#' + id);
    track('mbe_karte', { karte: id, quelle: src || 'seite' });
    noteSeen(id);
    var back = card.querySelector('[data-mbe-close]');
    if (back) back.focus({ preventScroll: true });
    return true;
  }
  function closeCardNow(card) {
    card.querySelectorAll('video').forEach(function (v) { v.pause(); });
    card.classList.remove('is-open');
    card.hidden = true;
    resetIn(inOf(card));
    if (!document.querySelector('.mbe-card.is-open')) clearSides();
    syncLock();
  }
  function closeCard() {
    var card = document.querySelector('.mbe-card.is-open');
    if (!card) return;
    if (history.state && history.state.mbe === card.id) { history.back(); return; }
    closeCardNow(card);
    if (hashId() === card.id) history.replaceState(history.state, '', location.pathname + location.search + (overlay && overlay.classList.contains('is-open') ? '#ergebnisse' : ''));
  }

  /* ---------- Blättern: Nachbarkarte fährt sichtbar mit ---------- */
  var EASE = 'cubic-bezier(.22,.7,.2,1)', GAP = 16;
  function resetIn(inner) {
    if (!inner) return;
    inner.style.transition = ''; inner.style.transform = ''; inner.style.opacity = ''; inner.style.pointerEvents = ''; inner.style.filter = '';
  }
  function inOf(card) { return card.querySelector('.mbe-card__in'); }
  function cardList(card) {
    return Array.prototype.filter.call(card.parentNode.children, function (n) { return n.hasAttribute && n.hasAttribute('data-mbe-card'); });
  }
  function neighbour(card, dir) {
    var list = cardList(card);
    if (list.length < 2) return null;
    var i = list.indexOf(card);
    return list[(i + dir + list.length) % list.length];
  }

  /* Breite Bildschirme: Karussell mit Nachbarkarten links / rechts */
  var lastDir = 1;
  function place(el, x, W, t) {
    var a = Math.min(Math.abs(x) / W, 2);
    var s = 1 - 0.12 * Math.min(a, 1);
    /* Nachbarkarten bleiben deckend (nichts scheint durch) und werden nur abgedunkelt */
    var o = a <= 1 ? 1 : 2 - a;
    var b = 1 - 0.58 * Math.min(a, 1);
    el.style.transition = t ? 'transform ' + t + 's ' + EASE + ', opacity ' + t + 's ' + EASE + ', filter ' + t + 's ' + EASE : 'none';
    el.style.transform = 'translateX(' + x + 'px) scale(' + s + ')';
    el.style.opacity = o;
    el.style.filter = b < 0.999 ? 'brightness(' + b.toFixed(3) + ')' : '';
    el.style.pointerEvents = o < 0.15 ? 'none' : '';
  }
  function wideLayout(center, off, t, dir) {
    var list = cardList(center), n = list.length, i = list.indexOf(center);
    var W = inOf(center).offsetWidth + GAP;
    var ks;
    if (n < 2) ks = [0];
    else if (n === 2) ks = [0, dir < 0 ? -1 : 1];
    else if (n === 3) ks = [-1, 0, 1];
    else if (n === 4) ks = dir < 0 ? [-2, -1, 0, 1] : [-1, 0, 1, 2];
    else ks = [-2, -1, 0, 1, 2];
    var used = [];
    ks.forEach(function (k) {
      var c = list[((i + k) % n + n) % n];
      used.push(c);
      var fresh = false;
      if (k !== 0 && !c.classList.contains('is-side')) {
        c.hidden = false;
        c.classList.add('is-side');
        initCard(c);
        eager(c);
        inOf(c).scrollTop = 0;
        fresh = true;
      }
      place(inOf(c), k * W + off, W, fresh ? 0 : t);
    });
    list.forEach(function (c) {
      if (used.indexOf(c) < 0 && c.classList.contains('is-side')) {
        c.classList.remove('is-side');
        resetIn(inOf(c));
        if (!c.classList.contains('is-open')) c.hidden = true;
      }
    });
  }
  function clearSides() {
    document.querySelectorAll('.mbe-card.is-side').forEach(function (c) {
      c.classList.remove('is-side');
      resetIn(inOf(c));
      if (!c.classList.contains('is-open')) c.hidden = true;
    });
  }
  function wideCommit(card, dir) {
    var next = neighbour(card, dir);
    if (!next) return;
    busy = true;
    lastDir = dir;
    card.querySelectorAll('video').forEach(function (v) { v.pause(); });
    if (!next.classList.contains('is-side') || cardList(card).length === 2) { wideLayout(card, 0, 0, dir); void inOf(next).offsetWidth; }
    var W = inOf(card).offsetWidth + GAP;
    wideLayout(card, -dir * W, 0.42, dir);
    setTimeout(function () {
      card.classList.remove('is-open');
      card.classList.add('is-side');
      next.classList.remove('is-side');
      next.classList.add('is-open');
      openCard(next.id, false);
      history.replaceState({ mbe: next.id }, '', '#' + next.id);
      busy = false;
    }, 440);
  }
  function peek(card, dir) {
    var n = neighbour(card, dir);
    if (!n) return null;
    n.hidden = false;
    n.classList.add('is-peek');
    initCard(n);
    n.querySelectorAll('img[loading="lazy"]').forEach(function (i) { i.loading = 'eager'; });
    var ni = inOf(n);
    ni.scrollTop = 0;
    return n;
  }
  function unpeek(n) {
    if (!n) return;
    n.classList.remove('is-peek');
    if (!n.classList.contains('is-open')) n.hidden = true;
    resetIn(inOf(n));
  }
  function move(el, x, t) {
    el.style.transition = t ? 'transform ' + t + 's ' + EASE : 'none';
    el.style.transform = x ? 'translateX(' + x + 'px)' : 'none';
  }
  var busy = false;
  function commit(card, next, dir) {
    var ci = inOf(card), ni = inOf(next), W = ci.offsetWidth + GAP;
    busy = true;
    card.querySelectorAll('video').forEach(function (v) { v.pause(); });
    move(ci, -dir * W, .32);
    move(ni, 0, .32);
    setTimeout(function () {
      closeCardNow(card);
      resetIn(ci);
      next.classList.remove('is-peek');
      resetIn(ni);
      openCard(next.id, false);
      history.replaceState({ mbe: next.id }, '', '#' + next.id);
      busy = false;
    }, 330);
  }
  function stepCard(card, dir) {
    if (busy) return;
    if (wide()) { wideCommit(card, dir); return; }
    var next = peek(card, dir);
    if (!next) return;
    var W = inOf(card).offsetWidth + GAP;
    move(inOf(next), dir * W);
    void inOf(next).offsetWidth;
    commit(card, next, dir);
  }
  /* Einmaliger Hinweis: Karte schiebt sich kurz zur Seite und zeigt die nächste */
  var hinted = false;
  function hint(card) {
    if (hinted || busy || wide()) return;
    hinted = true;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    setTimeout(function () {
      if (!card.classList.contains('is-open') || busy || sw) return;
      var next = peek(card, 1);
      if (!next) return;
      busy = true;
      var ci = inOf(card), ni = inOf(next), W = ci.offsetWidth + GAP, d = Math.min(72, W * 0.2);
      move(ni, W);
      void ni.offsetWidth;
      move(ci, -d, .45); move(ni, W - d, .45);
      setTimeout(function () {
        move(ci, 0, .4); move(ni, W, .4);
        setTimeout(function () { resetIn(ci); unpeek(next); busy = false; }, 420);
      }, 650);
    }, 900);
  }

  /* Wischen mit dem Finger */
  var sw = null;
  document.addEventListener('touchstart', function (e) {
    var c = e.target.closest && e.target.closest('.mbe-card.is-open, .mbe-card.is-side');
    if (c && c.classList.contains('is-side')) c = document.querySelector('.mbe-card.is-open');
    if (!c && wide() && e.target.classList && e.target.classList.contains('mbe-bd')) c = document.querySelector('.mbe-card.is-open');
    if (!c || busy || e.touches.length !== 1) { sw = null; return; }
    var s = e.target.closest('[data-mbe-slides]');
    sw = { x: e.touches[0].clientX, y: e.touches[0].clientY, c: c, s: s, sl: s ? s.scrollLeft : 0, lock: null, dx: 0, n: null, dir: 0 };
  }, { passive: true });
  document.addEventListener('touchmove', function (e) {
    if (!sw || sw.lock === 'no') return;
    var dx = e.touches[0].clientX - sw.x, dy = e.touches[0].clientY - sw.y;
    if (!sw.lock) {
      if (Math.abs(dx) < 8 && Math.abs(dy) < 8) return;
      if (Math.abs(dx) < Math.abs(dy) * 1.2) { sw.lock = 'no'; return; }
      if (sw.s && sw.s.scrollWidth > sw.s.clientWidth + 2) {
        var atStart = sw.sl <= 2, atEnd = sw.sl + sw.s.clientWidth >= sw.s.scrollWidth - 2;
        if ((dx < 0 && !atEnd) || (dx > 0 && !atStart)) { sw.lock = 'no'; return; }
      }
      sw.lock = 'x';
    }
    var dir = dx < 0 ? 1 : -1;
    if (wide()) {
      sw.dir = dir; sw.dx = dx; sw.n = neighbour(sw.c, dir);
      wideLayout(sw.c, dx, 0, dir);
      return;
    }
    if (dir !== sw.dir) { unpeek(sw.n); sw.n = peek(sw.c, dir); sw.dir = dir; }
    sw.dx = dx;
    var W = inOf(sw.c).offsetWidth + GAP;
    move(inOf(sw.c), dx);
    if (sw.n) move(inOf(sw.n), dir * W + dx);
  }, { passive: true });
  document.addEventListener('touchend', function () {
    if (!sw) return;
    var d = sw; sw = null;
    if (d.lock !== 'x' || !d.n) return;
    var W = inOf(d.c).offsetWidth + GAP;
    if (wide()) {
      if (Math.abs(d.dx) > Math.min(90, W * 0.22)) { wideCommit(d.c, d.dir); return; }
      busy = true;
      wideLayout(d.c, 0, 0.3, d.dir);
      setTimeout(function () { busy = false; }, 320);
      return;
    }
    if (Math.abs(d.dx) > Math.min(90, W * 0.22)) {
      commit(d.c, d.n, d.dir);
    } else {
      busy = true;
      move(inOf(d.c), 0, .28);
      move(inOf(d.n), d.dir * W, .28);
      setTimeout(function () { resetIn(inOf(d.c)); unpeek(d.n); busy = false; }, 300);
    }
  }, { passive: true });

  /* ---------- Overlay (Lasche auf allen Seiten, Plakette auf Produktseiten) ---------- */
  var overlay = null, overlays = {};
  function overlayEl(url) {
    if (overlays[url]) return overlays[url];
    var ov = document.createElement('div');
    ov.className = 'mbe-ov';
    ov.setAttribute('role', 'dialog');
    ov.setAttribute('aria-modal', 'true');
    ov.innerHTML = '<button type="button" class="mbe-ov__close" data-mbe-ov-close aria-label="×">×</button><div class="mbe-ov__body"><div class="mbe-ov__load"></div></div>';
    document.body.appendChild(ov);
    overlays[url] = ov;
    return ov;
  }
  MBE.openOverlay = function (url, push) {
    if (document.querySelector('[data-mbe]:not(.mbe-ov [data-mbe])')) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }
    var ov = overlayEl(url);
    if (overlay && overlay !== ov) overlay.classList.remove('is-open');
    overlay = ov;
    ov.classList.add('is-open');
    ov.scrollTop = 0;
    syncLock();
    if (push !== false && hashId() !== 'ergebnisse') history.pushState({ mbeOv: 1 }, '', '#ergebnisse');
    if (ov.__loaded || ov.__loading) return;
    ov.__loading = true;
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (t) {
        var doc = new DOMParser().parseFromString(t, 'text/html');
        var body = ov.querySelector('.mbe-ov__body');
        body.innerHTML = '';
        Array.prototype.forEach.call(doc.body.childNodes, function (n) {
          if (n.nodeName === 'SCRIPT') return;
          body.appendChild(document.importNode(n, true));
        });
        body.querySelectorAll('script').forEach(function (s) { s.remove(); });
        ov.__loaded = true;
        warm(body);
      })
      .catch(function () { location.href = url.split('?')[0]; })
      .then(function () { ov.__loading = false; });
  };
  function closeOverlay() {
    if (!overlay || !overlay.classList.contains('is-open')) return;
    if (history.state && history.state.mbeOv) { history.back(); return; }
    overlay.classList.remove('is-open');
    syncLock();
  }

  /* ---------- Produktseite: Plakette am Foto + letzter Slide ---------- */
  function placeProduct() {
    var tpl = document.getElementById('mbe-pp');
    if (!tpl || tpl.__done) return;
    tpl.__done = true;
    var frag = tpl.content.cloneNode(true);
    var chip = frag.querySelector('.mbe-chip');
    var slide = frag.querySelector('.mbe-pslide');
    var gallery = document.querySelector('media-gallery');
    var mobile = window.matchMedia('(max-width: 749px)').matches;
    var firstItem = gallery && gallery.querySelector('.product__media-item');
    var title = document.querySelector('.product__info-container .product__title') || document.querySelector('.product__title');
    if (chip) {
      if (mobile && firstItem) {
        firstItem.style.position = 'relative';
        chip.classList.add('is-over');
        firstItem.appendChild(chip);
      } else if (title) {
        chip.classList.add('is-below');
        title.insertAdjacentElement('afterend', chip);
      }
    }
    var list = gallery && gallery.querySelector('.product__media-list');
    if (slide && list) {
      list.appendChild(slide);
      var slider = list.closest('slider-component');
      if (slider) {
        try {
          slider.sliderItems = slider.querySelectorAll('[id^="Slide-"]');
          if (slider.initPages) slider.initPages();
          if (slider.update) slider.update();
        } catch (err) {}
      }
    }
  }

  /* ---------- Warenkorb ---------- */
  function addToCart(btn) {
    var ids = String(btn.getAttribute('data-mbe-add') || '').split(',').filter(Boolean);
    if (!ids.length || btn.disabled) return;
    var label = btn.innerHTML, all = btn.hasAttribute('data-mbe-all');
    var cardEl = btn.closest('[data-mbe-card]'), cid = cardEl ? cardEl.id : '';
    track('mbe_warenkorb', { karte: cid, quelle: src || 'seite', anzahl: ids.length, alle: all });
    btn.disabled = true;
    btn.style.opacity = '.6';
    var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
    var mark = cid && consentOk();
    fetch(addUrl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: ids.map(function (id) { return { id: Number(id), quantity: 1, properties: mark ? { _Echte_Ergebnisse: cid } : {} }; }),
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) throw new Error(res.description || res.message || 'Error');
        var drawer = document.querySelector('cart-drawer');
        if (res.sections && drawer) {
          var parse = function (h, sel) { var d = new DOMParser().parseFromString(h, 'text/html').querySelector(sel); return d ? d.innerHTML : null; };
          var cd = document.getElementById('CartDrawer');
          var cdHtml = res.sections['cart-drawer'] && parse(res.sections['cart-drawer'], '#CartDrawer');
          if (cd && cdHtml != null) cd.innerHTML = cdHtml;
          drawer.classList.remove('is-empty');
          var inner = drawer.querySelector('.drawer__inner');
          if (inner) inner.classList.remove('is-empty');
          var bubble = document.getElementById('cart-icon-bubble');
          var bHtml = res.sections['cart-icon-bubble'] && parse(res.sections['cart-icon-bubble'], '.shopify-section');
          if (bubble && bHtml != null) bubble.innerHTML = bHtml;
          var ovl = drawer.querySelector('#CartDrawer-Overlay');
          if (ovl && drawer.close) ovl.addEventListener('click', drawer.close.bind(drawer));
        }
        if (all) {
          var c = document.querySelector('.mbe-card.is-open');
          if (c) closeCardNow(c);
          if (overlay) overlay.classList.remove('is-open');
          if (location.hash) history.replaceState(null, '', location.pathname + location.search);
          syncLock();
          if (drawer && drawer.open) drawer.open(); else location.href = (window.routes && window.routes.cart_url) || '/cart';
          btn.innerHTML = label;
        } else {
          btn.innerHTML = '✓';
          setTimeout(function () { btn.innerHTML = label; }, 1600);
        }
      })
      .catch(function (err) {
        btn.innerHTML = label;
        var msg = document.createElement('div');
        msg.style.cssText = 'font-size:12px;color:#B00020;padding-top:6px;grid-column:1/-1;';
        msg.textContent = err.message;
        (btn.closest('.mbe-prod') || btn.parentNode).appendChild(msg);
        setTimeout(function () { msg.remove(); }, 5000);
      })
      .then(function () { btn.disabled = false; btn.style.opacity = ''; });
  }

  /* ---------- Ereignisse ---------- */
  document.addEventListener('click', function (e) {
    var side = e.target.closest && e.target.closest('.mbe-card.is-side');
    if (side) {
      e.preventDefault();
      var oc0 = document.querySelector('.mbe-card.is-open');
      if (oc0 && !busy) wideCommit(oc0, neighbour(oc0, 1) === side ? 1 : -1);
      return;
    }
    var t = e.target.closest('[data-mbe-open],[data-mbe-close],[data-mbe-more],[data-mbe-add],[data-mbe-nav],[data-mbe-step],[data-mbe-ov-close],[data-mbe-ov-open]');
    if (!t) {
      var bg = e.target.classList && (e.target.classList.contains('mbe-card') || e.target.classList.contains('mbe-bd')) ? e.target : null;
      if (bg) closeCard();
      return;
    }
    if (t.hasAttribute('data-mbe-open')) {
      if (openCard(t.getAttribute('data-mbe-open'))) { e.preventDefault(); hint(findCard(t.getAttribute('data-mbe-open'))); }
    } else if (t.hasAttribute('data-mbe-close')) {
      e.preventDefault(); closeCard();
    } else if (t.hasAttribute('data-mbe-more')) {
      var story = t.parentNode.querySelector('[data-mbe-story]');
      var open = story.classList.toggle('is-open');
      t.textContent = open ? t.getAttribute('data-less') : t.getAttribute('data-more');
    } else if (t.hasAttribute('data-mbe-add')) {
      e.preventDefault(); addToCart(t);
    } else if (t.hasAttribute('data-mbe-nav')) {
      var s = t.closest('.mbe-card__media').querySelector('[data-mbe-slides]');
      s.scrollBy({ left: s.clientWidth * Number(t.getAttribute('data-mbe-nav')), behavior: 'smooth' });
    } else if (t.hasAttribute('data-mbe-step')) {
      stepCard(t.closest('.mbe-card'), Number(t.getAttribute('data-mbe-step')));
    } else if (t.hasAttribute('data-mbe-ov-close')) {
      closeOverlay();
    } else if (t.hasAttribute('data-mbe-ov-open')) {
      e.preventDefault();
      src = srcOf(t);
      track('mbe_oeffnen', { quelle: src, seite: location.pathname });
      noteSeen(null);
      MBE.openOverlay(t.getAttribute('data-mbe-ov-open'));
    }
  });
  document.addEventListener('keydown', function (e) {
    var oc = document.querySelector('.mbe-card.is-open');
    if (oc && (e.key === 'ArrowRight' || e.key === 'ArrowLeft')) { stepCard(oc, e.key === 'ArrowRight' ? 1 : -1); return; }
    if (e.key !== 'Escape') return;
    if (oc) closeCard();
    else if (overlay && overlay.classList.contains('is-open')) closeOverlay();
  });
  window.addEventListener('popstate', function () {
    var h = hashId();
    var open = document.querySelector('.mbe-card.is-open');
    if (open && open.id !== h) closeCardNow(open);
    if (h && h !== 'ergebnisse' && findCard(h)) openCard(h, false);
    if (overlay && overlay.classList.contains('is-open') && h !== 'ergebnisse' && !(h && overlay.querySelector('#' + CSS.escape(h)))) {
      overlay.classList.remove('is-open');
    }
    syncLock();
  });
  function boot() {
    var h = hashId();
    if (h && document.getElementById(h) && document.getElementById(h).hasAttribute('data-mbe-card')) {
      history.replaceState({}, '', location.pathname + location.search);
      history.pushState({ mbe: h }, '', '#' + h);
      openCard(h, false);
    }
  }
  /* Trackpad / Maus: horizontales Wischen blättert auf breiten Bildschirmen */
  var wAcc = 0, wLast = 0, wT = null;
  document.addEventListener('wheel', function (e) {
    var oc = document.querySelector('.mbe-card.is-open');
    if (!oc || !wide() || Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
    var s = e.target.closest && e.target.closest('[data-mbe-slides]');
    if (s && s.scrollWidth > s.clientWidth + 2) {
      var atStart = s.scrollLeft <= 2, atEnd = s.scrollLeft + s.clientWidth >= s.scrollWidth - 2;
      if ((e.deltaX > 0 && !atEnd) || (e.deltaX < 0 && !atStart)) return;
    }
    wAcc += e.deltaX;
    clearTimeout(wT);
    wT = setTimeout(function () { wAcc = 0; }, 250);
    if (!busy && Math.abs(wAcc) > 60 && Date.now() - wLast > 700) {
      wLast = Date.now();
      stepCard(oc, wAcc > 0 ? 1 : -1);
      wAcc = 0;
    }
  }, { passive: true });
  /* Gerät gedreht / Fenster geändert: Anordnung neu berechnen */
  function relayout() {
    var oc = document.querySelector('.mbe-card.is-open');
    if (!oc || busy || sw) return;
    if (wide()) wideLayout(oc, 0, 0, lastDir); else { clearSides(); resetIn(inOf(oc)); }
    syncLock();
  }
  if (WIDE.addEventListener) WIDE.addEventListener('change', relayout); else if (WIDE.addListener) WIDE.addListener(relayout);
  var rT = null;
  window.addEventListener('resize', function () { clearTimeout(rT); rT = setTimeout(relayout, 120); });
  /* Fotos einer Karte schon beim Antippen / Überfahren der Kachel laden */
  document.addEventListener('pointerover', function (e) {
    var t = e.target.closest && e.target.closest('[data-mbe-open]');
    if (t && !t.__mbeW) { t.__mbeW = true; eager(findCard(t.getAttribute('data-mbe-open'))); }
  }, { passive: true });
  document.addEventListener('touchstart', function (e) {
    var t = e.target.closest && e.target.closest('[data-mbe-open]');
    if (t && !t.__mbeW) { t.__mbeW = true; eager(findCard(t.getAttribute('data-mbe-open'))); }
  }, { passive: true });
  function start() {
    try { if (window.Shopify && Shopify.loadFeatures) Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () {}); } catch (err) {}
    if (document.querySelector('[data-mbe]:not(.mbe-ov [data-mbe])')) {
      src = 'seite';
      track('mbe_oeffnen', { quelle: 'seite', seite: location.pathname });
    }
    boot();
    placeProduct();
    if (document.querySelector('[data-mbe-card]')) warm(document);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
